module.exports = __webpack_public_path__ + "img/antes_despues_39.dde7c590.png";